const config = {
    server:'/yme-workbench/',
    env:'',
    appid:process.env.APP_ID,
    baseUrl: process.env.NODE_ENV === 'development' ? '/web-app/' : '/web-app/',
    mapKey:'JKSBZ-HQI66-DIVSR-EGWFY-2IGOQ-OWBH7',
    env_version:process.env.ENV_VERSION || 'release', // 要打开的小程序版本。正式版为"release"，体验版为"trial"，开发版为"develop"，仅在微信外打开时生效。
    miniProgramType:process.env.MINI_PROGRAM_TYPE || 0, //0 正式版 1体验版 2 开发板
    serviceUrl:process.env.SERVICEURL,
    vconsole:process.env.VCONSOLE
}
//  === 'development' ? 'wxe2ed47ee197169f6' : 'wxa179488a3358eeea'

export default config

//开发人员的opeInd 白名单 可以显示微信的复制分享等按钮 方便调试
export const openIdArr = ['ocBYK67K4cMXRinTvm-d1CQGLSRg'] //线上的

